// extracted by mini-css-extract-plugin
module.exports = {"container":"_12-rLqJibQoc3ykKksJKXF","containerButton":"_1KuH6YMH59Kh6Ehlvynx7S","boxButtons":"_35XKXd4xxrOuQHmFHBLqPh"};